const FilterModal = ({
  toggleModal,
  selectedFilter,
  setSelectedFilter,
  filter,
}: {
  toggleModal: () => void;
  selectedFilter?: "30" | "60" | "90" | null;
  setSelectedFilter: (value: "30" | "60" | "90" | null) => void;
  filter: () => void;
}) => {
  const filters: Array<"30" | "60" | "90"> = ["30", "60", "90"];
  return (
    <div className="fixed flex flex-1 top-0 left-0 right-0 bottom-0 z-20 w-full bg-black/30 justify-center items-start text-black h-full min-h-screen">
      <div className="relative w-full max-w-[calc(480px)] max-h-full mt-[calc(100px)]">
        <div className="relative bg-white rounded-2xl shadow p-5">
          <div className="w-full flex flex-col items-center pb-3">
            <div className="w-full flex justify-end">
              <button onClick={toggleModal}>
                <span className="font-bold">X</span>
              </button>
            </div>
            <div className="w-full flex justify-start">
              <p className="text-md mt-3 mb-3">Período</p>
            </div>
            <div className="w-full grid grid-cols-3 gap-4">
              {filters?.map((filter, index) => (
                <button
                  key={index}
                  className={`border border-1 ${selectedFilter === filter ? "border-black text-principal font-bold bg-black" : "border-gray-500 text-gray-500"} p-1 text-base rounded-lg`}
                  onClick={() => setSelectedFilter(filter)}
                >
                  {filter} dias
                </button>
              ))}
            </div>
            <button type="button" onClick={filter} className="mt-8 bg-black border p-2 rounded-lg h-[calc(60px)] text-principal w-full">Continuar</button>
            <button type="button" onClick={() => setSelectedFilter(null)} className="mt-4 mb-3 p-2 text-black underline">Limpar filtros</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FilterModal;